import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Page } from "#/components/page";
import { SettingsPage } from "#/components/settings-page";
import { useUser } from "#/modules/util.auth/use-user";
import { m } from "#/paraglide/messages";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/admin/account-settings",
)({
  component: AccountSettingsLayout,
});

// Portal's admin `AccountSettingsLayout` — same shell as the school variant, but not
// school-scoped: it links to the admin account-settings tabs.
function AccountSettingsLayout() {
  const user = useUser();

  if (!user) {
    return null;
  }

  return (
    <SettingsPage>
      <SettingsPage.Header>
        <Page.Title>
          {user.firstName} {user.lastName}
        </Page.Title>
        <p className="text-muted-foreground text-sm">{user.email}</p>
      </SettingsPage.Header>

      <SettingsPage.Body>
        <SettingsPage.Nav>
          <SettingsPage.NavLink
            from={Route.fullPath}
            to="/$locale/{-$schoolyear}/admin/account-settings/account-info"
            params={(prev: Record<string, string>) => prev}
          >
            {m["account.account_info"]()}
          </SettingsPage.NavLink>
          <SettingsPage.NavLink
            from={Route.fullPath}
            to="/$locale/{-$schoolyear}/admin/account-settings/security"
            params={(prev: Record<string, string>) => prev}
          >
            {m["account.security"]()}
          </SettingsPage.NavLink>
        </SettingsPage.Nav>

        <SettingsPage.Content>
          <Outlet />
        </SettingsPage.Content>
      </SettingsPage.Body>
    </SettingsPage>
  );
}
